<template>
  <v-main class="main-container">
    <Miscellaneous />
  </v-main>
</template>

<script>
import Miscellaneous from "@/components/templates/Miscellaneous";

export default {
  components: { Miscellaneous },
};
</script>
